export default function downloadFile(data: Blob | string, fileName: string, extension: string) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    const extensionValidation = extension ? `.${extension}` : "";
    link.href = url;
    link.setAttribute("download", `${fileName}${extensionValidation}`);
    document.body.appendChild(link);

    link.click();

    link.parentNode?.removeChild(link);
}
